import { render, staticRenderFns } from "./DashboardDictionaryDatatable.vue?vue&type=template&id=6edfb13c&scoped=true"
import script from "./DashboardDictionaryDatatable.vue?vue&type=script&lang=js"
export * from "./DashboardDictionaryDatatable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6edfb13c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6edfb13c')) {
      api.createRecord('6edfb13c', component.options)
    } else {
      api.reload('6edfb13c', component.options)
    }
    module.hot.accept("./DashboardDictionaryDatatable.vue?vue&type=template&id=6edfb13c&scoped=true", function () {
      api.rerender('6edfb13c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/customer-insigths/components/DashboardDictionaryDatatable.vue"
export default component.exports